import React from "react";
import { Modal, Button } from "react-bootstrap";

const ClientOrdersDetailModal = ({ show, onHide, clientorders }) => {
  if (!clientorders) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Client Order Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong> Client Name :</strong>{" "}
          {clientorders.client_id ? clientorders.client_id.name : "N/A"}
        </p>
        <p>
          <strong> Hub Name :</strong>{" "}
          {clientorders.hub_id ? clientorders.hub_id.name : "N/A"}
        </p>
        <p>
          <strong>Order Status:</strong> {clientorders.order_status}
        </p>
        <p>
          <strong>Total Amount:</strong> {clientorders.total_amount}
        </p>
        <p>
          <strong>Deliver Address:</strong> {clientorders.address}
        </p>
        <p>
          <strong>Delivery Date : </strong>{" "}
          {formatDate(clientorders.delivery_date)}
        </p>
        {/* <p>
          <strong>Delivery Address:</strong> {clientorders.delivery_address}
        </p> */}
        <p>
          <strong> DA Name :</strong>{" "}
          {clientorders.daUserId ? clientorders.daUserId.name : "-"}
        </p>
        <p>
          <strong> Driver Name :</strong>{" "}
          {clientorders.driver_id ? clientorders.driver_id.name : "-"}
        </p>
        <p>
          <strong> Number Plate :</strong>{" "}
          {clientorders.vehicle_id ? clientorders.vehicle_id.numberplate : "-"}
        </p>
        <p>
          <strong>Customer Name :</strong>{" "}
          {clientorders.customer_detail
            ? clientorders.customer_detail.customer_name
            : "N/A"}
        </p>
        <p>
          <strong> Customer Contact :</strong>{" "}
          {clientorders.customer_detail
            ? clientorders.customer_detail.customer_phone
            : "N/A"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientOrdersDetailModal;
